<template>
  <tr :class="handleTRCssClasses(item, canEdit)"
  :style="handleTRCssStyles(item)"
  @click="disableKeyboardFunc && handleClickedItem(item)"
  @dblclick="handleDoubleClick(item)"
  >
    <td v-if="showSelect" @click.stop>
      <v-layout row wrap>
        <v-checkbox  v-if="!handleDisableCheckboxes(item)"
        v-model="selectedTask" :value="item"
        class="pl-3 shrink ma-0" hide-details />
      </v-layout>
    </td>
    <td
      v-for="header in headerList" :key="header.value"
      :class="determineCssClasses(item, canEdit, header)"
    >
      <span v-if="header.formatter === 'file'"
        @click.stop
      >
        <UploadFile
        class="changeHeightSize"
          v-if=item.hasFiles
          :bucketName="uploadFileParams.bucketName"
          :program="uploadFileParams.program"
          :parentObjectType="uploadFileParams.parentObjectType"
          :parentObjectId="item._id"
          :itemIsSaved="true"
          :showText="false"
        ></UploadFile>
      </span>
      <span v-else-if="header.formatter === 'localDateTime'">
        {{toLocalDateTime(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'shortDate'">
        {{toShortDate(resolveSubProp(header.value, item))}}
      </span>

      <span v-else-if="header.formatter === 'amountCanbeBlank'"
      :style="{color: changeTxtColor(item, header)}">
        {{amountFormatCanbeEmpty(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'amount' && header.clickable"
      class="clickable-amount"
      :style="{color: changeTxtColor(item, header)}"
      @click="handleButtonClick(item)">
        {{amountFormat(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'amount'"
      :style="{color: changeTxtColor(item, header)}">
        {{amountFormat(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'amountOrZero'"
      :style="{color: changeTxtColor(item, header)}">
        {{ resolveSubProp(header.value, item) ?
         amountFormat(resolveSubProp(header.value, item)): ''}}
      </span>
      <span v-else-if="header.formatter === 'auto'">
        {{autoDetectFormat(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'getFirstChar'">
        {{getFirstChar(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'boolToStr'">
        {{boolToStr(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'customMethod'"
      :style="{color: changeTxtColor(item, header)}">
        {{header.methodDefinition(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'pId'">
        {{pIdFormat(resolveSubProp(header.value, item), formatPidPositions)}}
      </span>
      <span v-else-if="header.formatter === 'combineName'"
       :class="changeTheTextColor(item, header)">
        {{combinedNames(item, header)}}
      </span>
      <span v-else-if="header.formatter === 'shortenCharacter'"
      :title="shouldTitleDisplay(resolveSubProp(header.value, item))">
        {{shortenCharacterFormat(resolveSubProp(header.value, item),
         header, item)}}
      </span>
      <span v-else-if="header.formatter === 'flagToYorEmpty'">
        {{flagToYorEmpty(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'propertyTaxTypeShortCode'">
        {{propertyTaxTypeShortCode(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'voidTransactionId'" v-html="voidTransactionId(resolveSubProp(header.value, item), item)">
      </span>
      <span v-else-if="header.formatter === 'hideAndShowFields'">
        {{hideAndShowFields(resolveSubProp(header.value, item))}}
      </span>
      <span v-else-if="header.formatter === 'button'">
        <v-btn class="input-text-size ma-0 pa-0"
            style="height: 15px;"
            text color="blue darken-1"
            @click="handleButtonClick(item)"
          >{{header.buttonText || 'Button'}}</v-btn>
      </span>
      <span v-else :style="{color: changeTxtColor(item, header)}">
        {{resolveSubProp(header.value, item)}}
      </span>
    </td>
    <td v-if="canDelete" @click.stop>
      <v-icon
        icon
        small class="mr-2"
        @click="deleteRowItem(item)"
      >
        {{icons.mdiDelete}}
      </v-icon>
    </td>
    <td v-if="canDownload" @click.stop>
      <v-icon
        icon
        small class="mr-2"
        @click="downloadRowItem(item)"
      >
        {{icons.mdiDownload}}
      </v-icon>
    </td>
  </tr>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  mdiPencil,
  mdiDelete,
  mdiChevronDown,
  mdiChevronUp,
  mdiDownload,
} from '@mdi/js';
import {
  amountFormat, amountFormatCanbeEmpty,
  toLocalDateTime,
  resolveSubProp,
  shortenCharacterFormat,
  pIdFormat,
  combinedNames,
  hideAndShowFields,
} from '../../../../util/shared/vue-global';
import {
  toShortDate,
  getFirstChar,
  boolToStr,
  flagToYorEmpty,
  propertyTaxTypeShortCode,
} from '../../../../util/shared/tmc-global';
import '../../../../assets/style.css';

import UploadFile from '../../UploadFile.vue';
// please don't use this widely throughout the project. It's
// specific logic for a specific screen, but I am exporting it
// for unit testing purposes.
export const autoDetectFormat = (valueStr = '') => {
  const value = (valueStr != null) ? valueStr.toString() : '';
  if (value.match(/Coordinated Universal Time/)) {
    return new Date(valueStr).toLocaleString();
  }
  if (value.match(/[0-9.,$]/) && value.match(/[.,$]/) && !value.match(/[a-zA-Z]/)) {
    const strIsCurrency = value.match(/[$]/) ? '$' : '';
    const bareAmount = value.replace(/[,$]*/g, '');
    return `${strIsCurrency}${amountFormat(bareAmount, true)}`;
  }
  return value;
};

export default {
  name: 'CRUDRow',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => ([]),
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canMove: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    canDownload: {
      type: Boolean,
      default: false,
    },
    uploadFileParams: {
      type: Object,
      default: () => ({}),
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    formatPidPositions: {
      type: String,
      default: '',
    },
    showExpand: {
      type: Boolean,
      default: false,
    },
    disableKeyboardFunc: {
      type: Boolean,
      default: true,
    },
    variableToChangeRowBgColor: {
      type: Array,
      default: () => ([]),
    },
    hideCheckbox: {
      type: String,
      default: '',
    },
    baseCrudKey: {
      type: String,
      default: 'default',
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    UploadFile,
  },
  data: () => ({
    icons: {
      mdiPencil,
      mdiDelete,
      mdiChevronDown,
      mdiChevronUp,
      mdiDownload,
    },
  }),
  computed: {
    ...mapGetters('base/crud', [
      'highlightedId',
    ]),
    headerList() {
      if (this.showSelect) {
        return this.headers.slice(1);
      }
      return this.headers;
    },
    selectedTask: {
      get() {
        return this.selectedItems || [];
      },
      set(value) {
        this.$emit('emitSelectedItem', value);
      },
    },
    getHighlightedId: {
      get() {
        return this.highlightedId(this.baseCrudKey) || '';
      },
      set(value) {
        this.setHighlightedId([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    resolveSubProp,
    amountFormat,
    amountFormatCanbeEmpty,
    toLocalDateTime,
    shortenCharacterFormat,
    pIdFormat,
    combinedNames,
    toShortDate,
    autoDetectFormat,
    getFirstChar,
    boolToStr,
    flagToYorEmpty,
    propertyTaxTypeShortCode,
    voidTransactionId(val, item) {
      if (!item.isVoid) return val || '';
      const id = val || '';
      if (!id) return '<span style="color:red;font-weight:bold;">VOID</span>';
      const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      if (id.length <= 16) return `${esc(id)}...<span style="color:red;font-weight:bold;">VOID</span>`;
      return `${esc(id.slice(0, 8))}...<span style="color:red;font-weight:bold;">VOID</span>...${esc(id.slice(-8))}`;
    },
    hideAndShowFields,
    // emitEditItem(item) {
    //   this.$emit('editItem', item);
    // },
    ...mapMutations('base/crud', [
      'setHighlightedId',
    ]),
    handleClickedItem(value) {
      this.$emit('emitClickedItem', value, 'fromClicked');
    },
    handleDisableCheckboxes(item) {
      const disabledStatus = item[this.hideCheckbox] || false;
      return disabledStatus;
    },
    handleTRCssStyles(item) {
      let backgroungClr = '';
      (this.variableToChangeRowBgColor || []).map((ft) => {
        if (item[ft.varName]) backgroungClr = ft.varCol || 'red';
        return '';
      });
      return { 'background-color': backgroungClr };
    },
    handleTRCssClasses(item, canEdit) {
      const classes = [];
      if (canEdit) classes.push('text-start ');
      // if (canEdit) classes.push('text-start clickable');
      else classes.push('text-start');
      if (this.getHighlightedId === item._id && this.disableKeyboardFunc) classes.push('selected-row-highlight');
      else classes.push('');
      // to add a class to last element
      const lastIndex = this.items.length ? this.items[this.items.length - 1]._id : '';
      if (lastIndex === item._id) classes.push('tr-last-index');
      return classes;
    },
    determineCssClasses(item, canEdit, header) {
      const classes = ['table-row-font-size', 'display-in-one-line'];
      if (item && item.crudRowCssAppend && Array.isArray(item.crudRowCssAppend)) {
        classes.push(...item.crudRowCssAppend);
      }
      if (canEdit) {
        classes.push('');
        // classes.push('clickable');
      }
      if (header && header.cellClass) classes.push(header.cellClass);
      if (header && header.align === 'right') {
        classes.push('text-align-right');
        classes.push('pointer');
      }
      if (header.align === 'center') classes.push('text-center');
      if (header.enableLine) classes.push('with-divider-left');
      return classes;
    },
    handleDoubleClick(item) {
      if (this.canEdit) this.$emit('editItem', item);
      if (this.canMove && !this.canEdit) this.$emit('editItem', item, 'canMove');
    },
    changeTxtColor(item, header) {
      if (header.formatterTwo === 'txtColorChange') {
        // to check for tax-due not 0 or not
        if (item.totalDue) return 'red';
      }
      if (header.formatterTwo === 'forteHighlight') {
        // Forte payments (POS/CC/E-Check) need to stand out from in-house/lockbox payments
        if (['fPOSPay', 'fCCPay', 'feCheckPay'].includes(item.paymentMethod)) return '#1565C0';
      }
      return '';
    },
    changeTheTextColor(item, header) {
      const checkItIsArrOrNot = header && header.changeTheTxtClrIfThisFieldsExits
        && header.changeTheTxtClrIfThisFieldsExits.length > 0
        ? header.changeTheTxtClrIfThisFieldsExits : [];
      return checkItIsArrOrNot.map((ft) => (item[ft] ? 'hightLightCRUDTextColor' : ''));
    },
    shouldTitleDisplay(val, chaLength = 20) {
      return (val && val.length > chaLength) ? val : '';
    },
    deleteRowItem(item) {
      this.$emit('emitDeleteRowItem', item);
    },
    downloadRowItem(item) {
      this.$emit('emitDownloadRowItem', item);
    },
    handleButtonClick(item) {
      this.$emit('emitRowButtonClick', item);
    },
  },
};
</script>

<style lang="sass">
.text-start .clickable:hover
  cursor: pointer
  font-weight: 600
.text-align-right
  text-align: right
.clickable-amount
  cursor: pointer
  color: #1565C0 !important
  text-decoration: underline
.table-row-font-size
  font-size: 0.75rem !important
.selected-row-highlight > td
  border-top: 2px solid #00ACC1 !important
  border-bottom: 2px solid #00ACC1 !important
.selected-row-highlight > td:first-child
  border-left: 2px solid #00ACC1 !important
.selected-row-highlight > td:last-child
  border-right: 2px solid #00ACC1 !important
</style>
